<script>
     import { resolveExportUrl } from "../../router.js";
     import LogDetails from "../components/logdetails.svelte";
    import wrappedFetch from "../../wrappedFetch.js";
    import { onMount } from "svelte";
    import Spinner from "../components/spinner.svelte";
    import DataTable from '../../components/data-table.svelte';
    import Modal from "../components/modal.svelte";
    import Card from "../components/card.svelte";

    let testExportDetails;
    let testGroupExportDetails;
    let isPageLoading = true;
    let isModalLoading = false;
    let selectedUser;
    export let role;
    role = role.charAt(0).toUpperCase() + role.slice(1);
    export let providerId;
    let titleProvider =  providerId == 1?"Google" :providerId == 3?"Microsoft":"";
    let pendingUserMatches=[];
    let showModal = false;
    const getTestExportDetails = async () => {
        let resp = await wrappedFetch(
            `/api/testExport/GetTestRunDetailsByRole?providerId=${providerId}&role=${role}`,
            {
                method: "post",
            }
        );      
        testExportDetails = await resp.json();
        isPageLoading = false;
        return testExportDetails;
    };

    const getTestGroupExportDetails = async () => {
        let resp = await wrappedFetch(
            `/api/testExport/GetTestRunDetailsForGroup?providerId=${providerId}`,
            {
                method: "post",
            }
        );      
        testGroupExportDetails = await resp.json();
        isPageLoading = false;
        return testGroupExportDetails;
    };

    const showMatchOptions = async (user) => {      
        isModalLoading = true;
        showModal = true;
        selectedUser = user;
        let resp = await wrappedFetch(
            `/api/testExport/GetTestPendingUsersMatches?pendingUserId=${user.id}`,
            {
                method: "post",
            }
        );      
        pendingUserMatches = await resp.json();    
        isModalLoading= false;   
        return testExportDetails;
    };

    onMount(() =>
    {
        if(role=="Groups")
        getTestGroupExportDetails();
        else if(role== "Staff" || role == "Pupil")
        getTestExportDetails();
});
</script>


<svelte:head>
<title> {role} Test Export | {titleProvider} | Wavenet Nimbus </title>
</svelte:head>

{#if isPageLoading}
    <Spinner />
{:else if role == "Groups"}
<LogDetails backURL={resolveExportUrl(providerId, '/testexport')}>
    <div slot="title">
    <h1>Test {role} Logs</h1>
        <p>
            Groups that will be created or matched once sync runs.<br/>
            These are approximate numbers and might not exactly match the output from sync.
        </p>
    </div>
    <div slot="tab1Header">Created</div>
    <div slot="tab1Content">
        <DataTable message="There were no records to create group." DataLength={testGroupExportDetails.groupsCreated.length}  ResponsiveHeader='0,1'>
            <thead>
                <tr>
                    <th width="20%">Name</th> 
                    <th width="20%">Description</th>                  
                    <th width="20%">Email</th>  
                    <th width="20%">Supervisor Email</th>  
                    {#if providerId == "3" }
                    <th width="20%">Type</th> 
                    {/if}
                 
                </tr>
            </thead>
            <tbody>
                {#each testGroupExportDetails.groupsCreated as group}
                    <tr>
                        <td>{group.name || ''}</td>
                        <td>{group.description || ''}</td>
                        <td>{group.email || ''}</td>                     
                        <td>{group.supervisorEmail || ''}</td>    
                        {#if providerId == "3" }
                        <td>{group.isSecurityGroup ? "Security Group":"365 Group"}</td> 
                        {/if}
                    </tr>
                {/each}
            </tbody>
        </DataTable>
    </div>
    <div slot="tab2Header">Updated</div>
    <div slot="tab2Content">
        <DataTable message="There were no records to update group." DataLength={testGroupExportDetails.groupsUpdated.length}  ResponsiveHeader='0,1'>
            <thead>
                <tr>
                    <th width="20%">Name</th> 
                    <th width="20%">Description</th>                  
                    <th width="20%">Email</th>  
                    <th width="20%">Supervisor Email</th>  
                    {#if providerId == "3" }
                    <th width="20%">Type</th> 
                    {/if}
                 
                </tr>
            </thead>
            <tbody>
                {#each testGroupExportDetails.groupsUpdated as group}
                <tr>
                    <td>{group.name || ''}</td>
                    <td>{group.description || ''}</td>
                    <td>{group.email || ''}</td>                     
                    <td>{group.supervisorEmail || ''}</td>    
                    {#if providerId == "3" }
                    <td>{group.isSecurityGroup ? "Security Group":"365 Group"}</td> 
                    {/if}
                </tr>
                {/each}
            </tbody>
        </DataTable>
    </div>
</LogDetails>
{:else}
<LogDetails backURL={resolveExportUrl(providerId, '/testexport')}>
    <div slot="title">
    <h1>Test {role} Logs</h1>
        <p>
            Lists of users that are expected to be created, matched, marked as pending or disabled by the sync.<br/>
            These are approximate numbers only and might not exactly match the output from sync.
        </p>
    </div>
    <div slot="tab1Header">Created</div>
    <div slot="tab1Content">
        <DataTable message="No new users expected to be created." DataLength={testExportDetails.usersCreated.length}  ResponsiveHeader='0,1'>
            <thead>
                <tr>
                    <th width="20%">Name</th>                  
                    <th width="20%">Email</th>  
                 
                </tr>
            </thead>
            <tbody>
                {#each testExportDetails.usersCreated as user}
                    <tr>
                        <td>{user.name || ''}</td>
                        <td>{user.email || ''}</td>                     
                    </tr>
                {/each}
            </tbody>
        </DataTable>
    </div>
    <div slot="tab2Header">Matched</div>
    <div slot="tab2Content">       
        <DataTable message="There were no records to match." DataLength={testExportDetails.usersUpdated.length}  ResponsiveHeader='0,1'>
            <thead>
                <tr>
                    <th width="20%">Name</th>                  
                    <th width="20%">Email</th>  
                 
                </tr>
            </thead>
            <tbody>
                {#each testExportDetails.usersUpdated as user}
                    <tr>
                        <td>{user.name || ''}</td>
                        <td>{user.email || ''}</td>                     
                    </tr>
                {/each}
            </tbody>
        </DataTable>
    </div>
    <div slot="tab3Header">Pending</div>
    <div slot="tab3Content">
        <DataTable message="No users expected to be marked as pending." DataLength={testExportDetails.pendingUsers.length}  ResponsiveHeader='0,1'>
            <thead>
                <tr>
                    <th>Name</th>                  
                    <th>Email</th> 
                    <th>Reason</th>
                    <th></th> 
                 
                </tr>
            </thead>
            <tbody>
                {#each testExportDetails.pendingUsers as user}
                    <tr>
                    <td>{user.firstName} {user.lastName}</td>
                    <td>{user.primaryEmail || ''}</td>   
                    <td>{user.message}</td>
                    <td> <a
                        class="btn btn-grey TestExportMatchOptionbtn"
                        style="margin-top:-4px;"
                        href="#"
                        data={user.personId}
                        data-toggle="modal"
                        data-target=".match-options"
                        on:click={() => showMatchOptions(user)}>Match
                        Options</a></td>                  
                    </tr>
                {/each}
            </tbody>
        </DataTable>
    </div>
    <div slot="tab4Header">Disabled</div>
    <div slot="tab4Content">
        <DataTable message="No users expected to be disabled." DataLength={testExportDetails.usersDisabled.length}  ResponsiveHeader='0,1'>
            <thead>
                <tr>
                    <th width="20%">Name</th>                  
                    <th width="20%">Email</th>  
                 
                </tr>
            </thead>
            <tbody>
                {#each testExportDetails.usersDisabled as user}
                    <tr>
                        <td>{user.name || ''}</td>
                        <td>{user.email || ''}</td>                     
                    </tr>
                {/each}
            </tbody>
        </DataTable>
    </div>
</LogDetails>
{/if}

<Modal {showModal}
bind:isPageLoading ={isModalLoading}
    on:close={() => {
       
        showModal = false;
    }}
    targetClass="match-options">
    <div slot="header"> 
        <h4 class="title"> Match Options</h4>
    </div>
    <div slot="content">
        <Card>
            <div slot="header">  
                <h5 style="margin-bottom: 0;">Selected {role} </h5>
            </div>
            <div slot="body">
                <div
                    class="row"
                    style="margin-bottom: 2px;">
                    <div class="col-lg-6">
                        <label for="firstName"><b>First Name:</b></label>&nbsp;<span>{selectedUser.firstName || ''}</span>
                    </div>
                    <div class="col-lg-6">
                        <label for="dob"><b>Email:</b></label>&nbsp;<span>{selectedUser.primaryEmail || ''}</span>
                    </div>
                    <div class="col-lg-6">
                        <label for="lastName"><b>Last Name:</b></label>&nbsp;<span>{selectedUser.lastName || ''}</span>
                    </div>
                    <div class="col-lg-6">
                        <label for="dob"><b>Reason:</b></label>&nbsp;<span class="text-danger">{selectedUser.message?selectedUser.message: ''}</span>
                    </div>
                </div>              
            </div>
        </Card>       

        <br />
    
        {#if pendingUserMatches.length > 0}
            <!-- <p><b>Or Possible Matches</b></p> -->     
                <Card>
                    <div slot="header">  
                        <h5 style="margin-bottom: 0;">Matches in {#if providerId == 1}Google{:else}Microsoft{/if}</h5>
                    </div>
                    <div slot="body">
                        <DataTable DataLength={pendingUserMatches.length} message="There is currently no possible matches"  ResponsiveHeader='0,1' tableCSS='table-responsive'>
                            <thead>
                                <tr style="background-color:rgba(0, 0, 0, 0.03)">
                                    <th><b>First Name</b></th>
                                    <th><b>Last Name</b></th>
                                    <th><b>Email</b></th>
                                   
                                </tr>
                            </thead>
                            <tbody>
                                {#each pendingUserMatches as u}
                                    <tr>
                                        <td>{u.firstName || ''}</td>
                                        <td>{u.lastName || ''}</td>
                                        <td>{u.primaryEmail || ''}</td>                                         
                                    </tr>
                                {/each}
                            </tbody>
                        </DataTable>
                    </div>
                </Card>   
        {/if}
    </div>
   
</Modal>